var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root-header-section"},[_c('two-column-header-partial',{attrs:{"content":_vm.promoContent}},[_c('div',{staticClass:"decoration",attrs:{"slot":"decoration"},slot:"decoration"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }